import { createStore } from 'redux'
import {notesReducer} from '../state/reducers/general_reducer'
export const store = createStore(notesReducer)